var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: {
          fields: _vm.fields,
          items: _vm.items,
          "table-class": "text-nowrap",
          responsive: "",
          hover: "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(shipper)",
            fn: function (data) {
              return [
                _c(
                  "h4",
                  { staticClass: "mb-0" },
                  [
                    _c(
                      "b-link",
                      {
                        attrs: {
                          to: {
                            name: "admin-shipper",
                            params: { id: data.item.shipper.id },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(data.item.shipper.name) +
                            " - " +
                            _vm._s(data.item.shipper.license) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "cell(actions)",
            fn: function (data) {
              return [
                _c(
                  "no-permission-wrapper",
                  { attrs: { show: !_vm.canUpdateShippers } },
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: {
                          variant: "primary",
                          disabled: !_vm.canUpdateShippers,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return (() =>
                              _vm.onClickUpdatePrice(
                                data.item.shipper_price
                              )).apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n          Edit\n        ")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "no-permission-wrapper",
                  { attrs: { show: !_vm.canUpdateShippers } },
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: {
                          variant: "danger",
                          disabled: !_vm.canUpdateShippers,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return (() =>
                              _vm.onClickDeletePrice(
                                data.item.shipper_price
                              )).apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n          Delete\n        ")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }